/**
 * This plugin does not modify the `L.Draggable` API; it adapts marker drag
 * coordinates in `L.Marker` when rotation or pitch is enabled.
 *
 * @external L.Draggable
 * 
 * @see https://github.com/Leaflet/Leaflet/tree/v1.9.3/src/dom/Draggable.js
 */

/**
 * A class for making DOM elements draggable (including touch support).
 * Used internally for map and marker dragging. Only works for elements
 * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
 *
 * @since leaflet-rotate (v0.1.0)
 */

L.Draggable.include({

    /** @TODO */
    // updateMapBearing(mapBearing) {
    //     this._mapBearing = mapBearing;
    // },

});